export default __webpack_public_path__ + "static/media/sad-nodi-reduce.c3f09045.webp";